import {
  Component,
  OnInit,
  ElementRef,
  AfterContentInit,
  NgZone,
} from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import MousePosition from 'ol/control/MousePosition';
import { createStringXY } from 'ol/coordinate';
import { Draw } from 'ol/interaction';
import { NotificationService } from 'src/app/Service/notification.service';
import { Router } from '@angular/router';
import { OtherService } from 'src/app/Service/other.service';
import { MapService } from 'src/app/Service/map.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import momentJalaali from 'moment-jalaali';
import { Point, Polygon } from 'ol/geom';
import Feature from 'ol/Feature';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { DataService } from 'src/app/Service/data.service';
import { Fill, Icon, Stroke, Style } from 'ol/style';
import { BingMaps, TileWMS, WMTS, XYZ } from 'ol/source';
import { defaults as defaultControls, FullScreen } from 'ol/control';
import { Compiler } from '@angular/core';
import { StateManagementMenucarService } from 'src/app/Service/state-management-menucar.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { SignalrService } from 'src/app/Service/signalr.service';
import {
  IAlarm,
  ILocationChanged,
  ISubUser,
} from 'src/app/shared/models/signalR-model';
import axios from 'src/app/Service/axios';
import axios_2 from 'src/app/Service/axios-dotone';
import { environment } from 'src/environments/environment';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import MVT from 'ol/format/MVT';
import { getVectorTileStyle } from 'src/app/Service/map-styles';
declare let $: any;

interface MapLayer {
  id: number;
  name: string;
  imageUrl: string;
  disabled?: boolean;
}

@Component({
  selector: 'map',
  templateUrl: './map.component.html',
  styles: [
    `
      span {
        font-size: clamp(14px, 2vw, 16px);
      }
    `,
    `
      .layer-disabled {
        user-select: none;
        pointer-events: none;
        opacity: 0.5;
      }
    `,
  ],
})

export class MapComponent implements OnInit {
  showGuide: boolean = false;
  map: any = {};
  formData: any;
  mapSatelait: boolean = false;
  timeoutId: any = 0;
  car: any;
  showInfo: boolean = true;
  deviceInfo: boolean = false;
  acssess: any;
  GeoFenceData: any;
  GeoFenceId: number = -1;
  source: any;
  vector: any;
  draw: any;
  polygonEvent: any;
  polyganName = new FormControl();
  tooltipData: any;
  layers: any = [];
  version: string = `${(<any>window).version}`;
  appName: string = `${(<any>window).appName}`;
  webAppName = (<any>window).webAppName;
  menuModalId: any;
  exportPdf: boolean = false;
  modalMenuTitle: string = '';
  analysisId: any;
  location: any;
  allCar: any;
  helpData: any;
  holidays: any;
  holidaySelection: any = [];
  selectedItem: any;
  bDonotShowMap: boolean = false;
  bExpiredComp: boolean = false;
  bShowTripComp: boolean = false;
  editMode: boolean = false;
  bShowLayers: boolean = false;
  isHubConnect: boolean = false;
  isLiveTracking: boolean = false;
  private bOfflineMap: boolean = (<any>window).bOfflineMap;
  private strMapUrl: string = (<any>window).strMapUrl;
  private maxZoom = 20;

  hasTrafficAccess: boolean = JSON.parse(this.gurdService.decrypt(window.localStorage.getItem('menu') as any)).bTrafficMap;

  mapLayers: MapLayer[] = [
    {
      id: 0,
      name: 'نقشه معابر',
      imageUrl: '../../../assets/Img/نقشه معابر.svg',
    },
    {
      id: 1,
      name: 'نقشه ماهواره‌ای',
      imageUrl: '../../../assets/Img/نقشه ماهواره ایی.png',
    },
    {
      id: 2,
      name: 'لایه ترافیک',
      imageUrl: '../../../assets/Img/نقشه ترافیک.svg',
    },
  ];

  iLayer: number[] | any = [0];

  lst_Tooltip: any = [];

  // hubConnection Variables
  isHubEnabled = environment.baseUrlHub ?? '';

  private alarmAudio = new Audio('assets/sounds/SOS-Alarm.wav');
  private vehicleUpdatedBuffer = new window.Map();
  private markerLayer!: VectorLayer<VectorSource>;
  private alarmSource = new VectorSource();
  private alarmLayer = new VectorLayer({
    source: this.alarmSource,
    zIndex: 20,
  });

  private allMarkers = new window.Map(); // strUnitID -> Feature
  private carIndexMap = new window.Map(); // strUnitID
  private lastHoverTime = 0;
  private flushScheduled = false;
  private destroy$ = new Subject<void>();
  private hubHandlersBound = false;
  private tooltipActionsBound = false;

  constructor(
    private el: ElementRef,
    private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private mapService: MapService,
    private deviceService: DeviceDetectorService,
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private _compiler: Compiler,
    private stateManagement: StateManagementMenucarService,
    private gurdService: GurdServiceService,
    private _signalRService: SignalrService,
    private ngZone: NgZone,
  ) {
    if (window.location.host.includes('localhost')) {
      this.alarmAudio.src =
        'https://notificationsounds.com/storage/sounds/file-sounds-1221-emergence.mp3';
    }

    var data = window.localStorage.getItem('menu') as any;

    this.acssess = JSON.parse(this.gurdService.decrypt(data));

    this.bDonotShowMap = !this.acssess.bDonotShowMap;

    this.deviceInfo = this.deviceService.isDesktop();

    if (!this.deviceInfo) {
      this.closeMenu();
    }

  }

  datasabt: FormGroup = this.formBuilder.group({
    gps: new FormControl('1'),

    date: new Date().valueOf(),
  });
  datasabtPolygan: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });
  dataPeriodAz: FormGroup = this.formBuilder.group({
    date: momentJalaali().format('jYYYY/jMM/01'),
  });
  dataPeriodTa: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });
  datasabtStop: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });
  dataTa: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });
  dataWorkAz: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });
  dataWorkTa: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });

  async ngOnInit(): Promise<void> {
    await this.otherService.login();

    this._signalRService.isHubConnected$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isConnect: boolean) => {
        this.isHubConnect = isConnect;
        this.registerHubListeners();
        if (this.allCar?.length <= 200) {
          this.toggleLiveTracking();
        }
      });

    this._signalRService.isLiveLocationTracking$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isTracking: boolean) => {
        this.isLiveTracking = isTracking;
      });

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

    $('#savePolygan').off('hidden.bs.modal');
    $(document).off('click.mapCarDetails', '.map-car-details-btn');

    $('#map_tooltip').tooltip('hide');
    $('#map_tooltips').tooltip('hide');

    // this._signalRService.disconnect();
  }

  async ngAfterViewInit(): Promise<void> {
    await this.getHelp();

    if (!this.bDonotShowMap) {
      await this.getArea();
    }

    if (!this.bDonotShowMap) {
      this.newOpenMap();
      this.bindMapEvents();
      await this.getCar();
    }

    if (this.stateManagement.geoFence_Management != undefined) {
      this.GeoFence(this.stateManagement.geoFence_Management);
    }

    $('.clockpicker').clockpicker({
      donetext: 'top',

      align: 'top',

      autoclose: true,
    });

    $('#savePolygan')
      .off('hidden.bs.modal')
      .on('hidden.bs.modal', () => {
        this.source.removeFeature(this.polygonEvent);

        this.polyganName.setValue('');
      });

    this.bindTooltipActions();

    this._signalRService.init();

    this.startGuide();
  }

  private startGuide() {
    if (this.bOfflineMap) {
      try {
        const seenLayersGuide = localStorage.getItem('seenLayersGuide');

        if (!seenLayersGuide) {
          const timestamp = new Date().getTime();
          localStorage.setItem('seenLayersGuide', JSON.stringify(timestamp));
          this.showGuide = true;
        }
      } catch (error) {
        console.error('Error accessing localStorage for guide:', error);
      }
    }
  }

  private bindMapEvents() {
    this.vector.getSource().on('addfeature', (e: any) => {
      this.polygonEvent = e.feature;

      this.map.removeInteraction(this.draw);

      $('#savePolygan').modal('show');
    });

    this.map.on('pointermove', (e: any) => {
      const now = performance.now();
      if (now - this.lastHoverTime < 60) return;
      this.lastHoverTime = now;

      if (e.dragging) return;

      const pixel = this.map.getEventPixel(e.originalEvent);
      const hit = this.map.hasFeatureAtPixel(pixel);
      this.map.getViewport().style.cursor = hit ? 'pointer' : '';

      const feature = this.map.forEachFeatureAtPixel(e.pixel, (f) => f, {
        layerFilter: (layer) => layer === this.markerLayer,
      });

      if (feature) {
        this.displayCarDetails(feature, e.pixel, true);
      }
    });

    this.map.on('click', (e: any) => {
      if (e.dragging) return;

      const feature = this.map.forEachFeatureAtPixel(
        e.pixel,
        (f) => f,

        { layerFilter: (layer) => layer === this.markerLayer },
      );

      if (feature) {
        this.displayCarDetails(feature, e.pixel);
      } else {
        $('#map_tooltip').tooltip('hide');

        $('#map_tooltips').tooltip('hide');
      }
    });

    this.map.getView().on('propertychange', (e: any) => {
      var tooltip = $('#map_tooltip');

      tooltip.tooltip('hide');

      this.tooltipData = null;
    });
  }

  private bindTooltipActions() {
    if (this.tooltipActionsBound) return;

    this.tooltipActionsBound = true;

    $(document)
      .off('click.mapCarDetails', '.map-car-details-btn')
      .on('click.mapCarDetails', '.map-car-details-btn', (event: any) => {
        const target = event.currentTarget as HTMLAnchorElement;
        const unitId =
          $(target).data('unitId') || $(target).attr('data-unit-id');
        const href = target.getAttribute('href');

        if (href) {
          window.open(href, '_blank');
        } else if (unitId) {
          const url = this.router.serializeUrl(
            this.router.createUrlTree(['/carInfo', String(unitId).trim()]),
          );
          window.open(url, '_blank');
        }

        event.preventDefault();
        $('#map_tooltip').tooltip('hide');
        $('#map_tooltips').tooltip('hide');
      });
  }

  private registerHubListeners() {
    if (this.hubHandlersBound) return;

    this.hubHandlersBound = true;

    // force signOut
    this._signalRService.forceSignOut$.subscribe(() => {
      this.notifyService.showWarning(
        'برای حفظ امنیت، به‌صورت خودکار از حساب خارج شدید.',
        'ورود همزمان شناسایی شد',
      );

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { error: 'force-signOut' },
      });
    });

    // when subUser connected
    this._signalRService.subUserConnected$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        const user = JSON.parse(data.toString()) as ISubUser;
        this.notifyService.showInfo('وارد سامانه شد', user.strFullName);
      });

    // when subUser disconnected
    this._signalRService.subUserDisconnected$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        const user = JSON.parse(data.toString()) as ISubUser;
        this.notifyService.showWarning('از سامانه خارج شد', user.strFullName);
      });

    // when alarm triger
    this._signalRService.alarm$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: IAlarm) => {
        let res = JSON.parse(data.toString());

        this.processIncomingAlarm(res);
      });

    // when car location updated
    this.ngZone.runOutsideAngular(() => {
      this._signalRService.locationChanged$
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: any) => {
          let res = JSON.parse(data.toString()) as ILocationChanged;

          this.bufferVehicleUpdates(res);
        });

      this._signalRService.locationChangedBatch$
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: any) => {
          let res = JSON.parse(data.toString()) as ILocationChanged[];
          this.bufferVehicleUpdates(res);
        });
    });

    // when hub throw an error
    this._signalRService.hubError$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.notifyService.showError(data);
      });
  }

  reConnectHub() {
    this._signalRService.reconnect();
  }

  async processIncomingAlarm(response: IAlarm) {
    if (response.tiDeviceEventsType == 2) {
      this.playAlarm(1);

      // this.notifyService.showError(response.strMessage);

      // window.open(`/carInfo/${response.strUnitID}`, '_blank');
    }

    if ([6, 13, 32].includes(response.tiDeviceEventsType) && false) {
      this.notifyService.showError(response.strMessage);

      window.open(`/carInfo/${response.strUnitID}`, '_blank');
    }

    if (response.bDashCam) {
      let model = this.otherService.stringNumberToNumber({
        iSystemUser: this.gurdService.decrypt(
          window.localStorage.getItem('ID')!,
        ),

        strSession: this.gurdService.decrypt(
          window.localStorage.getItem('Session')!,
        ),

        strUnitID: response.strUnitID,

        strSDate: momentJalaali().format('jYYYY/jMM/jDD'),

        strEDate: momentJalaali().format('jYYYY/jMM/jDD'),
      });

      const resp = await axios_2.post(`FleetYar_VehicleliveURL`, model);

      let res = resp.data;

      if (res.iResult == 0) return this.notifyService.showError(res.strError);

      window.open(res.LiveURL, '_blank');
    }
  }

  newOpenMap() {
    this.source = new VectorSource({ wrapX: false });
    this.vector = new VectorLayer({ source: this.source });

    if (this.bOfflineMap && this.strMapUrl) {
      this.layers.push(
        new TileLayer({
          source: new XYZ({
            url: this.strMapUrl,
            attributions: 'Map data ©RayanAndishehNasr',
          }),
          visible: true,
          maxZoom: 14,
        }),
      );
      this.maxZoom = 14;
    } else {
      this.layers.push(
        new TileLayer({
          visible: true,
          source: new OSM({})
        })
      );

    }

    this.layers.push(
      new TileLayer({
        source: new XYZ({
          url: 'https://sat.neshanmap.ir/v1.0/{z}/{x}/{y}',
          attributions: 'Map data ©Neshan',
        }),
        visible: false,
        maxZoom: 19,
      }),
      new VectorTileLayer({
        source: new VectorTileSource({
          url: 'https://tiles.raah.ir/tiles/traffic/{z}/{x}/{y}.pbf',
          // url: 'https://tiles.raah.ir/tiles/traffic/{z}/{x}/{y}.pbf?version=3',
          // url: 'https://traffic-tile.snappmaps.ir/data/v2/{z}/{x}/{y}.pbf',
          format: new MVT(),
          attributions: 'Map data © Raah',
        }),
        style: getVectorTileStyle,
        visible: false,
      }),
    );

    const mousePositionControl = new MousePosition({
      coordinateFormat: createStringXY(5),
      projection: 'EPSG:4326',
      className: 'custom-mouse-position',
      target: document.getElementById('mouse-position') as any,
    }) as any;

    this.map = new Map({
      controls: defaultControls().extend([
        mousePositionControl,
        new FullScreen(),
      ]),
      layers: this.layers,
      target: 'test',
      view: new View({
        center: olProj.fromLonLat([51.3833554, 35.6770113]),
        zoom: Math.min(13, this.maxZoom),
        maxZoom: this.maxZoom,
      }),
    });
  }

  toggleLayersContainer() {
    if (this.showGuide) {
      this.showGuide = false;
    }

    this.bShowLayers = !this.bShowLayers;
  }

  public changeTail(id?: number): void {
    if (id == undefined) {
      this.iLayer = this.iLayer[0] == 0 ? [0] : [1]
      id = this.iLayer[0] === 0 ? 1 : 0;
    }

    if (id == 2) {
      const visibility = this.layers[id].get('visible');
      this.layers[id].setVisible(!visibility);
      if (!this.iLayer.includes(id)) {
        this.iLayer.push(id);
        var view = this.map.getView();
        view.setMaxZoom(this.maxZoom);
        view.animate({
          zoom: 8,
        });

      } else {
        this.iLayer = this.iLayer.filter((layerId: number) => layerId !== id);
      }
      return;
    }

    const currentLayerId = (id !== undefined ? id : (this.iLayer ?? 0));
    this.iLayer = [currentLayerId];
    this.layers.forEach((layer: any, index: number) => {
      layer.setVisible(index === currentLayerId);
      if (index === currentLayerId) {
        this.maxZoom = layer.get('maxZoom') ?? this.maxZoom;
        var view = this.map.getView();
        view.setMaxZoom(this.maxZoom);
        if (view.get('zoom') == 14) {
          view.animate({
            zoom: this.maxZoom,
          });
        }
      }
    });
  }

  report(Id: any) {
    window.localStorage.setItem(
      'reportDataZa',
      this.gurdService.encrypt(this.dataPeriodAz.value.date),
    );

    window.localStorage.setItem(
      'reportDataTa',
      this.gurdService.encrypt(this.dataPeriodTa.value.date),
    );

    if (
      Id == 1 ||
      Id == 2 ||
      Id == 3 ||
      Id == 4 ||
      Id == 5 ||
      Id == 6 ||
      Id == 18 ||
      Id == 19
    ) {
      this.router.navigate([`report/${Id}`]);

      // return
    } else if (Id == 7) {
      this.router.navigate([`reportage/flowmeter`]);

      // return
    } else {
      window.localStorage.setItem(
        'RouteDate',
        this.gurdService.encrypt(this.dataPeriodTa.value.date),
      );

      this.router.navigate([`route/${Id}/${this.GeoFenceId}`]);
    }

    $('#menuModal').modal('hide');
  }

  getArea = async () => {
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    };
    const resp = await axios.post(`Radyab_GeoFence`, model);
    let respJson = JSON.parse(resp.data);
    this.GeoFenceData = respJson;
  };

  getCar = async () => {
    if (!this.dataService.carData_New) {
      await this.dataService.getData_New();

      // const storedCar = this.gurdService.encrypt(JSON.stringify(this.dataService.carData_New));

      // if (storedCar.length < 1024 * 1024 * 5) {
      //   localStorage.setItem('carData_New', storedCar);
      // } else {
      //   console.warn('Data too large for localStorage, skipping save');
      // }
    }

    this.allCar = this.dataService.carData_New;

    this.carfun(this.allCar);
  };

  async carfun(data: any, fit?: boolean) {
    const resp = { data } as any;

    if (resp.data[0]?.ISSessionExpired) {
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: '105' } });
      return;
    }

    if (!resp.data) {
      return this.notifyService.showError('بروز خطا در سامانه');
    }

    this.car = resp.data;

    this.buildCarIndexMap();
    this.ensureMarkerLayer();
    this.ensureAlarmLayer();

    if (this.car.length === 1 && this.car[0].bIncomplete) {
      const unitId = this.getUnitId(this.car[0]);

      if (unitId) {
        return this.router.navigate([`/entryCar/1/${unitId}`]);
      }

      return;
    }

    const extent = this.map.getView().calculateExtent(this.map.getSize());
    const zoom = this.map.getView().getZoom();

    for (let index = 0; index < resp.data.length; index++) {
      const car = resp.data[index];

      const unitId = this.getUnitId(car);

      if (car.fLon === 0 && car.fLat === 0) continue;

      if (!unitId) continue;

      this.upsertCarFeature(car, unitId, extent, zoom);
    }

    // fit map
    if (fit !== false) {
      this.fitMap(resp.data);
    }

    this.applyExpiredState(resp.data);
  }

  private ensureMarkerLayer() {
    if (this.markerLayer) return;

    this.markerLayer = new VectorLayer<VectorSource>({
      source: new VectorSource(),
    });

    this.map.addLayer(this.markerLayer);
  }

  private ensureAlarmLayer() {
    const layers = this.map.getLayers().getArray();
    if (!layers.includes(this.alarmLayer)) {
      this.map.addLayer(this.alarmLayer);
    }
  }

  private getAlarmKey(unitId: string, alarm: any, index: number) {
    return `alarm-${unitId}-${alarm.iDeviceEvents ?? alarm.timestamp ?? index}`;
  }

  private buildCarTooltipHtml(car: any, unitId: string) {
    const detailUrl = this.router.serializeUrl(
      this.router.createUrlTree([`/carInfo/${unitId}`]),
    );

    const name = car?.strFullName || 'نامشخص';
    const type = car?.strMobileType_strComment || '';
    const online = !!car?.bOnline;
    const vehicleNo = car?.strVehicleNo || '—';
    const km = (car?.fLastKM ?? 0).toLocaleString();
    const speed = (car?.iSpeed ?? 0).toLocaleString();
    const date = car?.strTimeAge || '—';
    const device = car?.strDeviceStatus_strComment || (online ? 'آنلاین' : 'آفلاین');

    let tankerRows = '';
    if (car?.tiMobileType == 99) {
      tankerRows = `
                <div class="mk-tooltip__row">
                    <span class="mk-tooltip__lbl"><i class="fa fa-tint"></i>ظرفیت</span>
                    <span class="mk-tooltip__val">${(car.fCapacity ?? 0).toLocaleString()} لیتر</span>
                </div>
                <div class="mk-tooltip__row">
                    <span class="mk-tooltip__lbl"><i class="fa fa-tint"></i>آب موجود</span>
                    <span class="mk-tooltip__val">${(car.fVolume ?? 0).toLocaleString()} لیتر</span>
                </div>`;
    }

    const html = `<div class="mk-tooltip">
                <div class="mk-tooltip__head">
                    <div class="mk-tooltip__title">
                        <div class="mk-tooltip__name">${name}</div>
                        <div class="mk-tooltip__type">${type}</div>
                    </div>
                    <span class="mk-tooltip__dot ${online ? 'is-online' : 'is-offline'}"></span>
                </div>
                <div class="mk-tooltip__body">
                    <div class="mk-tooltip__row">
                        <span class="mk-tooltip__lbl"><i class="fa fa-tachometer"></i>کارکرد</span>
                        <span class="mk-tooltip__val">${km} کیلومتر</span>
                    </div>
                    <div class="mk-tooltip__row">
                        <span class="mk-tooltip__lbl"><i class="fa fa-tachometer"></i>سرعت</span>
                        <span class="mk-tooltip__val">${speed}</span>
                    </div>
                    <div class="mk-tooltip__row">
                        <span class="mk-tooltip__lbl"><i class="fa fa-hashtag"></i>پلاک</span>
                        <span class="mk-tooltip__val">${vehicleNo}</span>
                    </div>
                    <div class="mk-tooltip__row">
                        <span class="mk-tooltip__lbl"><i class="fa fa-calendar"></i>تاریخ</span>
                        <span class="mk-tooltip__val">${date}</span>
                    </div>
                    <div class="mk-tooltip__row">
                        <span class="mk-tooltip__lbl"><i class="fa fa-signal"></i>وضعیت دستگاه</span>
                        <span class="mk-tooltip__val">${device}</span>
                    </div>
                    ${tankerRows}
                </div>
                <a class="mk-tooltip__btn map-car-details-btn" data-unit-id="${unitId}" href="${detailUrl}" target="_blank" rel="noopener noreferrer">جزییات کامل</a>
            </div>`;

    const html2 = `<div class="mk-tooltip mk-tooltip--mini">
                <span class="mk-tooltip__dot ${online ? 'is-online' : 'is-offline'}"></span>
                <span class="mk-tooltip__name">${name}</span>
                <span class="mk-tooltip__type">${type}</span>
            </div>`;

    return { html, html2 };
  }

  private upsertCarFeature(car: any, unitId: string, extent: any, zoom: any) {
    if (!this.allMarkers.has(unitId)) {
      const coord4326 = olProj.transform(
        [car.fLon, car.fLat],
        'EPSG:4326',
        'EPSG:3857',
      );

      const feature = new Feature({
        geometry: new Point(coord4326),
        data: car,
      });

      const layerImage = new Icon({
        src: `../../../assets/mobile-icons/${car.strIconName}`,
        anchor: [0.1, 45],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
      });

      const style = new Style({
        image: layerImage,
      });

      feature.set('defaultStyle', style);
      feature.set('hidden', false); // visible by default
      feature.setStyle((f: Feature) => {
        return f.get('hidden') ? null : f.get('defaultStyle');
      });

      const { html, html2 } = this.buildCarTooltipHtml(car, unitId);
      feature.set('html', html);
      feature.set('html2', html2);

      this.markerLayer.getSource().addFeature(feature);
      this.allMarkers.set(unitId, feature);
      return;
    }

    // اگر marker قبلا ساخته شده، فقط موقعیتش رو آپدیت کن
    this.updateMarkerPosition(unitId, [car.fLon, car.fLat], extent, zoom);
  }

  private applyExpiredState(cars: any[]) {
    for (let index = 0; index < cars.length; index++) {
      const car = cars[index];

      if (cars.length > 1) {
        if (car.bExpired) {
          this.showExpiredCars();
        }
      } else {
        this.showExpired(car);
      }
    }
  }

  async showExpired(item: any) {
    let isShown: boolean =
      this.gurdService.decrypt(localStorage.getItem('bExpired')!) != ''
        ? true
        : false;

    const unitId = this.getUnitId(item);

    if (item.bExpired == true && !isShown && unitId) {
      window.localStorage.setItem(
        'bExpired',
        this.gurdService.encrypt(item.bExpired),
      );

      var model = {
        iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

        strSession: this.gurdService.decrypt(
          window.localStorage.getItem('Session')!,
        ),

        strUnitID: unitId,
      };

      const res = await axios.post(
        `Radyab_GetExpiredMessage`,
        this.otherService.stringNumberToNumber(model),
      );

      let response = JSON.parse(res.data);

      $.confirm({
        title: `${response.strAmount}`,

        content: '',

        type: 'blue',

        buttons: {
          cancel: {
            text: 'بستن',

            btnClass: 'btn-outline-danger',

            action: function () { },
          },

          ok: {
            text: ` تمدید ${item.strFullName}`,

            btnClass: 'btn-success',

            keys: ['enter'],

            action: () => {
              this.router.navigate(
                [`/carInfo/${unitId.trim()}`],

                { queryParams: { Renewal: true } },
              );
            },
          },
        },

        onOpenBefore: function () {
          if (response.bForcedRenewal) {
            this.buttons.cancel.disable(); //
          }
        },
      });

      return;
    }
  }

  async showExpiredCars() {
    let isShown: boolean =
      this.gurdService.decrypt(localStorage.getItem('bExpired')!) != ''
        ? true
        : false;

    if (!isShown) {
      window.localStorage.setItem('bExpired', this.gurdService.encrypt('true'));

      this.bExpiredComp = true;

      $('#expiredCars_Modal').modal('show');
    } else {
      // this.bExpiredComp = false;
    }
  }

  fitMap(data?: any) {
    if (!data) data = this.car;

    if (!data || data.length === 0) return;

    let minX = Infinity,
      minY = Infinity,
      maxX = -Infinity,
      maxY = -Infinity;
    let hasValidCoordinate = false;

    for (const car of data) {
      if (!car.fLon || !car.fLat) continue;

      const [x, y] = olProj.transform(
        [car.fLon, car.fLat],
        'EPSG:4326',
        'EPSG:3857',
      );

      if (x < minX) minX = x;
      if (x > maxX) maxX = x;
      if (y < minY) minY = y;
      if (y > maxY) maxY = y;
      hasValidCoordinate = true;
    }

    if (!hasValidCoordinate) return;

    const extent: [number, number, number, number] = [minX, minY, maxX, maxY];

    this.map.getView().fit(extent, {
      size: this.map.getSize(),
      padding: [150, 150, 150, 150],
      maxZoom: this.bOfflineMap ? 14 : 17,
    });

    if (data.length === 1) {
      this.map.getView().setZoom(this.bOfflineMap ? 14 : 17);
    }
  }

  savePolygon = async () => {
    var point = [] as any;
    this.draw.sketchLineCoords_.forEach((item: any, index: any) => {
      var data = this.mapService.transformCoordinates(item);
      point.push({ fLat: data[1], fLon: data[0] });
    });

    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strTitle: this.polyganName.value,
      lstPoints: point,
    };
    this.source.removeFeature(this.polygonEvent);
    $('#savePolygan').modal('hide');
    const resp = await axios.post(`Radyab_InsertGeoFence`, model);
    this.polyganName.setValue('');
    let respJson = JSON.parse(resp.data);
    if (respJson.iResult == 0) {
      this.notifyService.showError(respJson.strError);
    }
    if (respJson.ISSessionExpired == true) {
      this.otherService.removeLocalStorage();
      // this.router.navigate(['login']);
      this.router.navigate(['login'], { queryParams: { error: '106' } });

      return;
    }
    if (respJson.iResult == 1) {
      this.notifyService.showSuccess('با موفقیت ثبت شد');
      this.getArea();
    }
  };

  handelSos() {
    this.timeoutId = setTimeout(() => {
      this.sendSos();

      this.showInfo = false;
    }, 3000);
  }

  handelLeve() {
    clearTimeout(this.timeoutId);

    if (this.showInfo) {
      this.notifyService.showInfo(
        'برای ارسال پیام باید 3 ثانیه دکمه را نگه دارید',
        'نکته',
      );
    } else {
      this.showInfo = true;
    }
  }

  sendSos = async () => {
    var model = {
      id: `${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}`,
      fLat: 0,
      flon: 0,
    };
    const resp = await axios.post(`Radyab_SOS1`, model);

    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strMessage);
    } else {
      this.notifyService.showWarning(
        'درخواست کمک با موفقیت ارسال شد',
        'ارسال پیام',
      );
    }
  };

  reload() {
    this._compiler.clearCache();

    localStorage.removeItem('carData_New');

    window.location.reload();
  }

  openMenu() {
    if (
      !this.el.nativeElement
        .querySelector('menu-peysepar')
        .classList.contains('d-none')
    ) {
      this.el.nativeElement
        .querySelector('menu-peysepar')
        .classList.add('d-none');
    }

    let tag = this.el.nativeElement.querySelector('menu_item');
    tag.classList.contains('d-none')
      ? tag.classList.remove('d-none')
      : tag.classList.add('d-none');
    let bgTag = document.getElementById('bg-menu') as any;
    bgTag.classList.contains('d-none')
      ? bgTag.classList.remove('d-none')
      : bgTag.classList.add('d-none');
    var tooltip = $('#map_tooltip');
    tooltip.tooltip('hide');
    if (this.deviceInfo) {
      $('#test').css('right', '16%');
    }

    if (tag.classList.contains('d-none')) {
      $('#test').css('right', '0%');
    }
  }

  openPeyseparMenu() {
    if (
      !this.el.nativeElement
        .querySelector('menu_item')
        .classList.contains('d-none')
    ) {
      this.el.nativeElement.querySelector('menu_item').classList.add('d-none');
    }

    let tag = this.el.nativeElement.querySelector('menu-peysepar');

    tag.classList.contains('d-none')
      ? tag.classList.remove('d-none')
      : tag.classList.add('d-none');

    let bgTag = document.getElementById('bg-menu') as any;

    bgTag.classList.contains('d-none')
      ? bgTag.classList.remove('d-none')
      : bgTag.classList.add('d-none');

    var tooltip = $('#map_tooltip');

    tooltip.tooltip('hide');

    if (this.deviceInfo) {
      $('#test').css('right', '16%');
    }

    if (tag.classList.contains('d-none')) {
      $('#test').css('right', '0%');
    }
  }

  openMenuCar() {
    let tag = this.el.nativeElement.querySelector('menu_car');
    tag?.classList.remove('d-none');
    let bgTag = document.getElementById('bg-menu') as any;

    bgTag.classList.remove('d-none');
    var tooltip = $('#map_tooltip');
    tooltip.tooltip('hide');
  }

  closeMenu() {
    let tag = this.el.nativeElement.querySelector('menu_item');
    let tag2 = this.el.nativeElement.querySelector('menu_car');

    tag?.classList.add('d-none');
    tag2?.classList.add('d-none');
    let bgTag = document.getElementById('bg-menu') as any;

    bgTag?.classList.add('d-none');
    if (this.deviceInfo) {
      $('#test').css('right', '0%');
    }
  }

  displayCarDetails(feature: Feature, pixel: [number, number], hover?: boolean) {

    if (!feature) return;

    const html = feature.get('html');
    const html2 = feature.get('html2');

    if (!html) return;

    const tooltip: any = hover ? $('#map_tooltips') : $('#map_tooltip');

    const mapContainer = document.getElementById('map') || document.body;
    tooltip.tooltip({
      html: true,
      animation: true,
      trigger: 'manual',
      placement: 'top',
      fallbackPlacements: ['top', 'bottom', 'left', 'right'],
      boundary: mapContainer,
      offset: [0, 8],
      template: '<div class="tooltip mk-tip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner mk-tip-inner"></div></div>',
    });

    tooltip.css({
      left: pixel[0] + 'px',
      top: pixel[1] - 14 + 'px',
      zIndex: 1000,
    });

    if (!hover) {
      this.tooltipData = html;

      tooltip.attr('data-bs-original-title', html).tooltip('show');

      $('#map_tooltips').tooltip('hide');
    } else {
      if (this.tooltipData !== html) {
        tooltip.attr('data-bs-original-title', html2).tooltip('show');
      }
    }
  }

  sabt() {
    $('#exampleModal').modal('hide');

    this.router.navigate([`entryCar/${this.datasabt.value.gps}`]);
  }

  guid = async () => {
    this.otherService.guid(9);
  };

  GeoFence(item: any) {
    const selectedItem = this.GeoFenceData.find(
      (el: any) => el.iGeoFence == item.value,
    );

    if (selectedItem != undefined) {
      this.selectedItem = selectedItem;

      this.editMode = true;
    }

    if (item.value == -1) this.editMode = false;

    this.stateManagement.geoFence_Management = item;

    this.GeoFenceId = item.value;
    this.mapService.removeLayerByName('polygon', this.map);

    var ring = [];
    var data = this.GeoFenceData.filter((el: any) => {
      return el.iGeoFence == parseInt(item.value);
    });
    if (data.length != 0) {
      var loc = data[0].lstPoints;
      for (let index = 0; index < loc.length; index++) {
        ring.push([loc[index].fLon, loc[index].fLat]);
      }
      var polygon = new Polygon([ring]);
      polygon.transform('EPSG:4326', 'EPSG:3857');
      var feature = new Feature(polygon);
      var vectorSource = new VectorSource();
      vectorSource.addFeature(feature);
      var vectorLayer = new VectorLayer({
        source: vectorSource,
        name: 'polygon',
        style: new Style({
          stroke: new Stroke({
            color: 'red',
            width: 4,
            lineDash: [10, 20, 10, 20],
          }),
          fill: new Fill({
            color: 'rgba(0, 0, 255, 0)',
          }),
        }),
      } as any);
      this.map.addLayer(vectorLayer);
      this.fitMap(data[0].lstPoints);
    }
  }

  addInteraction() {
    this.mapService.removeLayerByName('polygon', this.map);

    this.selectedItem = undefined;

    this.editMode = false;

    const value = 'Polygon';

    this.draw = new Draw({
      source: this.source,

      type: value,
    });

    this.map.addInteraction(this.draw);
  }

  editArea() {
    this.polyganName.setValue(this.selectedItem.strTitle);

    $('#savePolygan').modal('show');
  }

  submitEditedTitle() {
    if (this.selectedItem.strTitle.trim() == this.polyganName.value.trim())
      return this.notifyService.showError('نام جدید با نام قبلی یکسان است');
    else {
      const index = this.GeoFenceData.indexOf(this.selectedItem);

      this.selectedItem.strTitle = this.polyganName.value;

      this.selectedItem.iSystemUser = this.gurdService.decrypt(
        localStorage.getItem('ID')!,
      );

      this.selectedItem.strSession = this.gurdService.decrypt(
        localStorage.getItem('Session')!,
      );

      $.confirm({
        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {
          ok: {
            text: 'ویرایش',

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {
              this.otherService.Showspinner();

              let res = JSON.parse(
                (
                  await axios.post(`Radyab_EditGeoFence`, this.selectedItem)
                ).data.toString(),
              );

              this.otherService.nonespinner();

              if (index != -1) this.GeoFenceData[index] = res;

              this.notifyService.showSuccess('با موفقیت ویرایش شد');

              $('#savePolygan').modal('hide');

              this.source.removeFeature(this.polygonEvent);

              this.polyganName.setValue('');

              this.mapService.removeLayerByName('polygon', this.map);

              this.editMode = false;
            },
          },

          cancel: {
            text: 'لغو',
          },
        },
      });
    }
  }

  deleteArea = () => {
    if (this.GeoFenceId != -1) {
      $.confirm({
        title: `آیا از حذف این محدوده اطمینان دارید؟`,
        content: '',
        type: 'red',
        buttons: {
          ok: {
            text: 'تایید',
            btnClass: 'btn-primary',
            keys: ['enter'],
            action: async () => {
              var model = {
                strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
                iSystemUser: this.gurdService.decrypt(
                  window.localStorage.getItem('ID')!,
                ),
                iGeoFence: this.GeoFenceId,
              };
              const resp = await axios.post(`Radyab_DeleteGeoFence`, model);
              var data = JSON.parse(resp.data);
              if (data.ISSessionExpired == true) {
                this.notifyService.showError('لطفا وارد سیستم شوید');
                this.otherService.removeLocalStorage();
                // this.router.navigate(['login']);
                this.router.navigate(['login'], {
                  queryParams: { error: '107' },
                });

                return;
              }

              if (data.iResult == 1) {
                this.mapService.removeLayerByName('polygon', this.map);
                this.notifyService.showSuccess('با موفقیت حذف شد');
                this.GeoFenceData = this.GeoFenceData.filter((el: any) => {
                  return el.iGeoFence != this.GeoFenceId;
                });
                this.GeoFenceId = -1;
              } else {
                this.notifyService.showError(resp.data.strError);
              }
            },
          },
          cancel: {
            text: 'لغو',
          },
        },
      });
    } else {
      this.notifyService.showWarning('لطفا محدوده ای را انتخاب کنید', 'هشدار');
    }
  };

  exportPdfMap = async () => {
    this.exportPdf = true;
    await this.mapService.getPdf(this.map);
    setTimeout(() => {
      this.exportPdf = false;
    }, 2000);
  };

  tripModal(isOpen: boolean) {
    if (isOpen) {
      this.bShowTripComp = true;

      $('#tripModal').modal('show');
    } else {
      $('#tripModal').modal('hide');
    }
  }

  hideTooltip() {
    var tooltip = $('#map_tooltip');
    tooltip.tooltip('hide');
  }

  openUploder() {
    $('#fileupload').click();
  }

  fileChange = async (event: any) => {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      this.formData = new FormData();
      this.formData.append('uploadFile', file, file.name);
    }
  };

  saveFile = async () => {
    if (!this.formData) {
      this.notifyService.showError('لطفا فایلی را بارگزاری کنید');
    }
    $.confirm({
      title: `آیا از ذخیره این فایل اطمینان دارید ؟`,
      content: '',
      type: 'blue',
      buttons: {
        ok: {
          text: 'ذخیره',
          btnClass: 'btn-success',
          keys: ['enter'],
          action: async () => {
            this.otherService.Showspinner();
            const resp = await axios.post(
              `MobilesReadExcelFile`,
              this.formData,
            );
            this.otherService.nonespinner();
            if (resp.data.iResult == 0) {
              this.notifyService.showError(resp.data.strError);
              return;
            }
            if (resp.data.ISSessionExpired == true) {
              this.notifyService.showError('لطفا وارد سیستم شوید');
              this.otherService.removeLocalStorage();
              // this.router.navigate(['login']);
              this.router.navigate(['login'], {
                queryParams: { error: '108' },
              });

              return;
            } else {
              this.notifyService.showSuccess(
                'فایل به درستی بارگذاری  گردید. جهت مشاهده حقوق به بخش حقوق در منوی اصلی یا گزارش های اختصاصی هر راننده مراجعه کنید',
              );
            }
            return;
          },
        },
        cancel: {
          text: 'لغو',
        },
      },
    });
  };

  getHelp = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      iType: 1,
    };
    this.otherService.Showspinner();
    const resp = await axios.post(`AppHelps`, model);
    this.otherService.nonespinner();
    this.helpData = JSON.parse(resp.data);
  };

  holidayData(event: any) {
    let currentYear = Number(momentJalaali().locale('fa').format('jYYYY'));
    this.holidaySelection = [];
    this.holidaySelection.push(
      currentYear,
      currentYear + 1,
      currentYear + 2,
      currentYear + 3,
    );
    this.holidays = event;
  }

  async changeHolidayYear(event: any) {
    let model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      iYear: event,
    };

    let res = JSON.parse(
      (await axios.post(`Holidays_List`, model)).data.toString(),
    );
    this.holidays = res;
  }

  deleteHoliday(item: any) {
    $.confirm({
      title: `آیا از حذف این روز تعطیل اطمینان دارید ؟`,
      content: '',
      type: 'red',
      buttons: {
        ok: {
          text: 'حذف',
          btnClass: 'btn-danger',
          keys: ['enter'],
          action: async () => {
            this.otherService.Showspinner();
            let model = {
              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
              iSystemUser: this.gurdService.decrypt(
                window.localStorage.getItem('ID')!,
              ),
              strDate: item.strDate,
            };
            const resp = await axios.post(`Holidays_Delete`, model);
            this.otherService.nonespinner();
            if (resp.data.iResult == 0) {
              this.notifyService.showError(resp.data.strError);
              return;
            }
            if (resp.data.ISSessionExpired == true) {
              this.notifyService.showError('لطفا وارد سیستم شوید');
              this.otherService.removeLocalStorage();
              // this.router.navigate(['login']);
              this.router.navigate(['login'], {
                queryParams: { error: '109' },
              });

              return;
            } else {
              this.notifyService.showSuccess(
                'تعطیلی مورد نظر با موفقیت حذف شد',
              );
              let date = document.getElementById('holidayYear') as any;
              this.changeHolidayYear(date.value);
            }
            return;
          },
        },
        cancel: {
          text: 'لغو',
        },
      },
    });
  }

  setNewHolidayModal() {
    $('#addHolidayModal').modal('show');
  }

  async saveHoliday() {
    let type = document.getElementById('holidayType') as any;
    let comment = document.getElementById('holidayComment') as any;

    let model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strDate: this.datasabt.controls['date'].value,
      tiType: type.value,
      strComment: comment.value,
    };

    let res = JSON.parse(
      (await axios.post(`Holidays_Save`, model)).data.toString(),
    );
    if (!res.strError) {
      $('#addHolidayModal').modal('hide');
      this.notifyService.showSuccess('اطلاعات با موفقیت ذخیره شد');
      let date = document.getElementById('holidayYear') as any;
      this.changeHolidayYear(date.value);
    } else return this.notifyService.showError(res.strError);
  }

  clickMethod(name: string) {
    $.confirm({
      title: '',
      content: `آیا از خروج حساب کاربری اطمینان دارید؟`,
      type: 'red',
      buttons: {
        ok: {
          text: 'تایید',
          btnClass: 'btn-danger',
          keys: ['enter'],
          action: () => {
            this.otherService.removeLocalStorage();
            this.dataService.carData_New = null;
            this.router.navigate(['login']);
            // window.location.reload();
          },
        },
        cancel: {
          text: 'لغو',
        },
      },
    });
  }

  // Hub Connection Function
  private getUnitId(item: any): string | null {
    const unitId = item?.strUnitID ?? item?.strUnitId;
    return unitId ? String(unitId) : null;
  }

  private buildCarIndexMap() {
    this.carIndexMap.clear();

    this.allCar.forEach((car, index: number) => {
      const unitId = this.getUnitId(car);

      if (!unitId) return;

      this.carIndexMap.set(unitId, index);
    });
  }

  private playAlarm(type: number) {
    const durations: Record<number, number> = { 1: 5000, 2: 2000 };
    const duration = durations[type] ?? 3000;
    const audio = this.alarmAudio;

    audio.volume = 0.5;
    audio.currentTime = 0;
    audio.play().catch(console.error);
    setTimeout(() => {
      audio.pause();
      audio.currentTime = 0;
    }, duration);
  }

  private bufferVehicleUpdates(updates: ILocationChanged | ILocationChanged[]) {
    if (Array.isArray(updates)) {
      for (const item of updates) {
        this.vehicleUpdatedBuffer.set(item.strUnitID, item);
      }
    } else {
      this.vehicleUpdatedBuffer.set(updates.strUnitID, updates);
    }

    this.scheduleFlush();
  }

  private scheduleFlush() {
    if (this.flushScheduled) return;

    this.flushScheduled = true;

    setTimeout(() => {
      this.flushVehicleUpdates();

      this.flushScheduled = false;
    }, 300);
  }

  private flushVehicleUpdates() {
    if (this.vehicleUpdatedBuffer.size === 0) return;

    const extent = this.map.getView().calculateExtent(this.map.getSize());
    const zoom = this.map.getView().getZoom();

    this.vehicleUpdatedBuffer.forEach(
      (data: ILocationChanged, unitId: string) => {
        const updatedCarIndex = this.carIndexMap.get(unitId);

        if (updatedCarIndex !== undefined) {
          Object.assign(this.allCar[updatedCarIndex], {
            fLon: data.fLon,

            fLat: data.fLat,

            iSpeed: data.iSpeed,

            siAngle: data.iAngle,

            strDate: data.strDate,

            strTime: data.strTime,

            strUnitId: data.strUnitID,
          });

          this.updateMarkerPosition(
            unitId,
            [Number(data.fLon), Number(data.fLat)],
            extent,
            zoom,
          );
        }
      },
    );

    this.vehicleUpdatedBuffer.clear();
  }

  updateMarkerPosition(
    unitId: string,
    newPosition: [number, number],
    extent: number[],
    zoom: number,
    duration = 300,
  ) {
    const feature = this.allMarkers.get(unitId);

    if (!feature) return;

    const geom = feature.getGeometry() as Point;

    if (!geom) return;

    const startCoord = geom.getCoordinates();
    const endCoord = olProj.transform(newPosition, 'EPSG:4326', 'EPSG:3857');

    const [x, y] = startCoord;

    const inViewport =
      x >= extent[0] && x <= extent[2] && y >= extent[1] && y <= extent[3];

    if (!inViewport || zoom < 14) {
      geom.setCoordinates(endCoord);

      return; // changed() لازم نیست
    }

    const startTime = performance.now();

    const animate = (time: number) => {
      const elapsed = time - startTime;

      let t = Math.min(elapsed / duration, 1);

      t = t * (2 - t);

      geom.setCoordinates([
        startCoord[0] + (endCoord[0] - startCoord[0]) * t,

        startCoord[1] + (endCoord[1] - startCoord[1]) * t,
      ]);

      if (t < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }

  toggleLiveTracking() {
    this._signalRService.updateLiveLocation(!this.isLiveTracking);
  }

  // menu_car emition
  filterCarMap(filteredCars: any[]) {
    this.car = filteredCars;
    if (!this.markerLayer || !this.markerLayer.getSource()) return;

    const visibleIds = new Set(
      filteredCars
        .map((x: any) => this.getUnitId(x))
        .filter((id: string | null): id is string => Boolean(id)),
    );

    this.markerLayer
      .getSource()
      .getFeatures()
      .forEach((f) => {
        const data = f.get('data');
        const unitId = this.getUnitId(data);
        f.set('hidden', !unitId || !visibleIds.has(unitId));
      });

    this.alarmSource.clear();
    this.markerLayer.getSource().changed(); // force render
  }

  showModal(id: any) {
    this.menuModalId = id;

    if (id == 1) {
      this.modalMenuTitle = 'گزارش پیمایش دوره ای';
    }

    if (id == 2) {
      this.modalMenuTitle = 'گزارش مصرف سوخت';
    }

    if (id == 3) {
      this.modalMenuTitle = 'گزارش خالص کارکرد روزانه';
    }

    if (id == 7) {
      this.modalMenuTitle = 'گزارش مصرف بر اساس فلومتر';
    } else if (id?.strUnitId) {
      this.menuModalId = id.strUnitId;

      window.localStorage.setItem(
        'carName',
        this.gurdService.encrypt(id.strFullName),
      );

      window.localStorage.setItem(
        'plate',
        this.gurdService.encrypt(id.strVehicleNo),
      );

      this.modalMenuTitle = 'بازه مد نظر خود را انتخاب کنید';
    }
  }

  async updateLocation(obj: { item: any; index: number }, zoomOnCar: boolean = true) {
    const extent = this.map.getView().calculateExtent(this.map.getSize());
    const zoom = this.map.getView().getZoom();

    this.updateMarkerPosition(
      obj.item.strUnitId,
      [Number(obj.item.fLon), Number(obj.item.fLat)],
      extent,
      zoom,
    );

    if (zoomOnCar) {
      this.focusCar(obj.item);
    }
  }

  async addAlarmOnMap(obj: { item: any; index: number; type?: 'alarm' | 'updateLocation' }, zoomOnCar: boolean = true) {
    const type = obj.type ?? 'updateLocation'; // default Value

    if (type === 'updateLocation') {
      return this.updateLocation(obj, zoomOnCar);
    }

    const alarm = obj.item;

    if (!alarm?.fLon || !alarm?.fLat) {
      this.notifyService.showWarning('', 'موقعیت یافت نشد');

      return;
    }

    const unitId = this.getUnitId(alarm);

    if (!unitId) return;

    const alarmKey = this.getAlarmKey(unitId, alarm, obj.index);

    const coords = olProj.fromLonLat([alarm.fLon, alarm.fLat]);

    let feature = this.alarmSource.getFeatureById(alarmKey);

    if (!feature) {
      feature = new Feature({
        geometry: new Point(coords),

        alarmData: alarm,
      });

      const layerImage = new Icon({
        src: `../../../assets/mobile-icons/danger.png`,
        scale: 0.8,
        anchor: [0.5, 1],
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction',
      });

      const style = new Style({
        image: layerImage,
      });

      feature.setId(alarmKey);
      feature.set('defaultStyle', style);
      feature.set('hidden', false); // visible by default
      feature.setStyle((f: Feature) => {
        return f.get('hidden') ? null : f.get('defaultStyle');
      });

      this.alarmSource.addFeature(feature);
    } else {
      const geometry = feature.getGeometry() as Point;

      geometry.setCoordinates(coords);

      feature.set('alarmData', alarm);
    }

    if (zoomOnCar) {
      this.map.getView().animate({
        center: coords,

        zoom: 16,

        duration: 500,
      });
    }
  }

  focusCar(data: any) {

    $('#map_tooltip').tooltip('hide');

    $('#map_tooltips').tooltip('hide');

    if (data.fLon != 0 && data.fLat != 0) {
      const unitId = this.getUnitId(data);
      if (!unitId) return;

      const feature: any = this.allMarkers.get(unitId);
      if (!feature) return;

      const oldData = feature.get('data') || {};
      const newData = { ...oldData, ...data };
      feature.set('data', newData);

      const { html, html2 } = this.buildCarTooltipHtml(newData, unitId);
      feature.set('html', html);
      feature.set('html2', html2);

      var view = this.map.getView();

      view.animate({
        zoom: this.maxZoom,
        center: olProj.transform(
          [newData.fLon, newData.fLat],
          'EPSG:4326',
          'EPSG:3857',
        ),
      });

      setTimeout(() => {
        const geom: any = feature.getGeometry();
        const coord = geom ? geom.getCoordinates() : olProj.transform(
          [newData.fLon, newData.fLat],
          'EPSG:4326',
          'EPSG:3857',
        );

        const pix = this.map.getPixelFromCoordinate(coord);
        if (!pix) return;

        this.displayCarDetails(feature, [pix[0], pix[1] - 32]);
      }, 1200);
    }
  }
  
}
